import { useDispatch } from "react-redux";
import JabatanMain from "../../../features/masters/jabatan/components/jabatan-main";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import { useEffect } from "react";

const title = "Master Jabatan";

const JabatanMasterPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <JabatanMain />;
};

export default JabatanMasterPage;
